import React, { useEffect, useState } from 'react';

const HotelList = ({ query }) => {
  const [hotels, setHotels] = useState([]);
  const [error, setError] = useState(null);

  const fetchCoordinates = async (query) => {
    const url = `https://weatherapi-com.p.rapidapi.com/current.json?q=${query}`;
    const options = {
      method: 'GET',
      headers: {
        'x-rapidapi-key': '8fd4cc5935msh55369f10316779ap1845e9jsneaa2d2f9d6f8',
        'x-rapidapi-host': 'weatherapi-com.p.rapidapi.com',
      },
    };

    try {
      const response = await fetch(url, options);
      const result = await response.json();
      console.log(result)
      return {
        lat: result.location.lat,
        lng: result.location.lon,
      };
    } catch (err) {
      console.error('Coordinate fetch failed:', err);
      return null;
    }
  };

  const fetchHotels = async (coords) => {
    const url = `https://travel-advisor.p.rapidapi.com/hotels/list-by-latlng?latitude=${coords.lat}&longitude=${coords.lng}&lang=en_US&limit=50`;
    const options = {
      method: 'GET',
      headers: {
        'x-rapidapi-key': '8fd4cc5935msh55369f10316779ap1845e9jsneaa2d2f9d6f8',
        'x-rapidapi-host': 'travel-advisor.p.rapidapi.com',
      },
    };

    try {
      const response = await fetch(url, options);
      const result = await response.json();
      console.log(result)
      setHotels(result.data || []);
      setError(null);
    } catch (err) {
      console.error('Hotel fetch failed:', err);
      setError('Failed to fetch hotels.');
      setHotels([]);
    }
  };

  useEffect(() => {
    const run = async () => {
      if (!query) return;

      const coords = await fetchCoordinates(query);
      if (!coords) {
        setError(`Could not find coordinates for "${query}"`);
        return;
      }

      await fetchHotels(coords);
    };

    run();
  }, [query]);

  return (
    <div style={{ padding: '1rem' }}>
     
      {error && <p style={{ color: 'red' }}>{error}</p>}
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
          gap: '1rem',
        }}
      >
        {hotels.map((hotel, index) => (
          <div
            key={index}
            style={{
              border: '1px solid #ccc',
              borderRadius: '8px',
              overflow: 'hidden',
              boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
              backgroundColor: '#fff',
            }}
          >
            {hotel.photo?.images?.medium?.url ? (
              <img
                src={hotel.photo.images.medium.url}
                alt={hotel.name}
                style={{ width: '100%', height: '180px', objectFit: 'cover' }}
              />
            ) : (
              <div
                style={{
                  height: '180px',
                  background: '#eee',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <span>No Image</span>
              </div>
            )}

            <div style={{ padding: '0.5rem' }}>
              <h3 style={{ fontSize: '1.1rem' }}>{hotel.name || 'Unnamed Hotel'}</h3>
              <p>{hotel.location_string}</p>

              {hotel.rating && (
                <p>
                  <strong>Rating:</strong> {hotel.rating}  ({hotel.num_reviews} reviews)
                </p>
              )}

              {hotel.price && (
                <p>
                  <strong>Price:</strong> {hotel.price}
                </p>
              )}

              {hotel.awards?.length > 0 && (
                <img
                  src={hotel.awards[0].images.small}
                  alt={hotel.awards[0].display_name}
                  style={{ marginTop: '0.5rem' }}
                />
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HotelList;
